import React, { useEffect, useState } from 'react';
import { Share, X } from 'lucide-react';

const DISMISSED_KEY = 'irecommend:a2hs-dismissed';

const isStandalone = () =>
  window.navigator.standalone === true ||
  window.matchMedia('(display-mode: standalone)').matches;

// Only Safari on iOS can add to the Home Screen, and it never prompts on its own.
const isIosSafari = () => {
  const ua = window.navigator.userAgent;
  const ios = /iPhone|iPad|iPod/.test(ua) ||
    (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
  const otherBrowser = /CriOS|FxiOS|EdgiOS|OPiOS|Instagram|FBAN|FBAV/.test(ua);
  return ios && !otherBrowser;
};

export const InstallHint = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!isIosSafari() || isStandalone()) return undefined;
    try {
      if (localStorage.getItem(DISMISSED_KEY)) return undefined;
    } catch {
      return undefined;
    }
    // Long enough that any sign-in toast has cleared before it appears.
    const id = setTimeout(() => setShow(true), 6000);
    return () => clearTimeout(id);
  }, []);

  const dismiss = () => {
    setShow(false);
    try {
      localStorage.setItem(DISMISSED_KEY, '1');
    } catch {
      /* private mode: the hint simply returns next visit */
    }
  };

  if (!show) return null;

  return (
    <div className="install-hint" role="note" data-testid="install-hint">
      <Share className="install-hint-icon" aria-hidden="true" />
      <p className="install-hint-text">
        Add irecommend to your Home Screen: tap
        {' '}
        <span className="install-hint-strong">Share</span>, then
        {' '}
        <span className="install-hint-strong">Add to Home Screen</span>.
      </p>
      <button
        className="install-hint-close"
        onClick={dismiss}
        aria-label="Dismiss Home Screen tip"
        data-testid="install-hint-dismiss"
      >
        <X />
      </button>
    </div>
  );
};
